/**
 * @generated SignedSource<<07c2084963d0ce9650a78f4d95b3448e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef$data = {
  readonly isAiEnabledInAdminHub?: boolean | null | undefined;
  readonly " $fragmentType": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef";
};
export type content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef$key = {
  readonly " $data"?: content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isGateIntentTemplatesBehindAiToggleEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef",
  "selections": [
    {
      "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAiEnabledInAdminHub"
        }
      ]
    }
  ],
  "type": "VirtualAgentFeatures"
};

(node as any).hash = "048c3ca8b9ef27d75ebbd4a504d5718c";

export default node;
